const FETCH_REVISION_STATUSES= "FETCH_REVISION_STATUSES";
const FETCH_REVISION_STATUSES_SUCCESS = "FETCH_REVISION_STATUSES_SUCCESS";
const FETCH_REVISION_STATUSES_ERROR = "FETCH_REVISION_STATUSES_ERROR";
const UPDATE_REVISION_STATUSES = "UPDATE_REVISION_STATUSES";
const UPDATE_REVISION_STATUSES_SUCCESS = "UPDATE_REVISION_STATUSES_SUCCESS";
const UPDATE_REVISION_STATUSES_ERROR = "UPDATE_REVISION_STATUSES_ERROR";
const DELETE_REVISION_STATUSES = "DELETE_REVISION_STATUSES";
const DELETE_REVISION_STATUSES_SUCCESS = "DELETE_REVISION_STATUSES_SUCCESS";
const DELETE_REVISION_STATUSES_ERROR = "DELETE_REVISION_STATUSES_ERROR";
const CREATE_REVISION_STATUSES = "CREATE_REVISION_STATUSES";
const CREATE_REVISION_STATUSES_SUCCESS = "CREATE_REVISION_STATUSES_SUCCESS";
const CREATE_REVISION_STATUSES_ERROR = "CREATE_REVISION_STATUSES_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const UPDATE_ORDER_REVISION_STATUS = "UPDATE_ORDER_REVISION_STATUS";
const UPDATE_ORDER_REVISION_STATUS_SUCCESS = "UPDATE_ORDER_REVISION_STATUS_SUCCESS";
const UPDATE_ORDER_REVISION_STATUS_ERROR = "UPDATE_ORDER_REVISION_STATUS_ERROR";

export {
  FETCH_REVISION_STATUSES,
  FETCH_REVISION_STATUSES_SUCCESS,
  FETCH_REVISION_STATUSES_ERROR,
  UPDATE_REVISION_STATUSES,
  UPDATE_REVISION_STATUSES_SUCCESS,
  UPDATE_REVISION_STATUSES_ERROR,
  DELETE_REVISION_STATUSES,
  DELETE_REVISION_STATUSES_SUCCESS,
  DELETE_REVISION_STATUSES_ERROR,
  CREATE_REVISION_STATUSES,
  CREATE_REVISION_STATUSES_SUCCESS,
  CREATE_REVISION_STATUSES_ERROR,
  UPDATE_ORDER_REVISION_STATUS,
  UPDATE_ORDER_REVISION_STATUS_SUCCESS,
  UPDATE_ORDER_REVISION_STATUS_ERROR,
  IS_ADDING_UPDATE,
};
